import { styled } from '@mui/system'
import BHTooltip from '../../../tooltip'

const Tooltip = styled(BHTooltip)`
	background-color: #f1f1f1;
	box-shadow: unset;
	max-width: unset;
	margin-top: 0 !important;
`

const WorkingRowWrapper = styled('div')`
	> span {
		display: contents;
	}
`

export { Tooltip, WorkingRowWrapper }
